import React from 'react';

import { getEnvDomain } from '../../config';
import { displayShortDate } from '../../utils/Format/Format';
import { getBoradAssetCategory } from '../../utils/fund-info';
import { CARD_NAMES } from '../../utils/constants';
import styles from './TopTenHoldingsBond.css';
import Card from '../../components/Card/Card';
import ErrorMessageNewFund from '../../components/ErrorMessages/ErrorMessageNewFund';
import ErrorMessageNoData from '../../components/ErrorMessages/ErrorMessageNoData';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import Toggle from '../../components/Toggle/Toggle';
import PeriodSelector from '../../components/PeriodSelector/PeriodSelector';

import { TOP_TEN_HOLDINGS_BOND } from './queries';
import { TopTenHoldingsBondUtil } from './util';
import { isExpectingMonthlyData } from '../../utils/time';

class TopTenHoldingsBond extends React.Component {
    state = {
        selectedPeriod: 'month'
    };

    togglePeriod = (period) => {
        this.setState({
            selectedPeriod: period
        });
    };

    handleChange = (event) => {
        const date = event.target.value;
        this.setState({
            selectedDate: date
        });
    };

    render() {
        const { ticker, moneyMarket } = this.props;
        const { selectedPeriod, selectedDate } = this.state;
        const trpDomain = getEnvDomain(window.location.host);
        return (
            <Card>
                <GqlQueryWrapper
                    query={TOP_TEN_HOLDINGS_BOND}
                    variables={{ ticker }}
                    dataFunc={TopTenHoldingsBondUtil(
                        selectedPeriod,
                        selectedDate
                    )}
                    placeholder={() => <TablePreRender />}
                    unbatch
                >
                    {({
                        data: {
                            data,
                            asOfDate,
                            inceptionDate,
                            broadAssetClass,
                            percentHoldings,
                            totalHoldings,
                            name,
                            effectiveDates,
                            buttonList
                        }
                    }) => {
                        if (!data || !data.length) {
                            if (!isExpectingMonthlyData(inceptionDate)) {
                                return (
                                    <ErrorMessageNewFund
                                        cardName={
                                            CARD_NAMES.TOP_TEN_HOLDINGS_BOND
                                        }
                                    />
                                );
                            }
                            return (
                                <ErrorMessageNoData
                                    cardName={CARD_NAMES.TOP_TEN_HOLDINGS_BOND}
                                />
                            );
                        }

                        return (
                            <React.Fragment>
                                <div
                                    className="title-group"
                                    data-testid="top-10-holdings-data"
                                >
                                    <div className="title">
                                        <TitleWithDescription
                                            title={`Top 10 Holdings${
                                                getBoradAssetCategory(
                                                    broadAssetClass
                                                )
                                                    ? ' - Equity Only'
                                                    : ''
                                            }`}
                                        />
                                    </div>
                                    <div className="buttons">
                                        <Toggle
                                            data={buttonList}
                                            selected={selectedPeriod}
                                            toggle={this.togglePeriod}
                                        />
                                    </div>
                                </div>
                                <div className="captions">
                                    <div className="as-of">
                                        <PeriodSelector
                                            selectedPeriod={selectedPeriod}
                                            data={effectiveDates}
                                            selectedDate={asOfDate}
                                            handleChange={this.handleChange}
                                        />
                                    </div>
                                </div>
                                <div
                                    id="top-10-holdings-table"
                                    className="tables"
                                >
                                    <Table
                                        data={{
                                            data,
                                            headers: [
                                                parseFloat(percentHoldings) > 0
                                                    ? `Represents\xa0${percentHoldings}\xa0of Total\xa0Net\xa0Assets`
                                                    : ``,
                                                'Coupon %',
                                                'Maturity'
                                            ]
                                        }}
                                    />
                                </div>
                                <div className="disclaimer">
                                    As of {displayShortDate(asOfDate)}, the{' '}
                                    {name} {/fund$/i.test(name) ? '' : 'Fund '}
                                    had a total of {totalHoldings} holdings.
                                </div>
                                {getBoradAssetCategory(broadAssetClass) && (
                                    <div className="disclaimer">
                                        Prior to May 31, 2024, the information
                                        shown does not reflect any ETFs that the
                                        portfolio may have held.
                                    </div>
                                )}
                                <div className="disclaimer">
                                    Holdings are as of the date indicated and
                                    are subject to change.
                                </div>
                                {data.filter(
                                    (row) => row.values.val1 === 'N/A'
                                ) && (
                                    <div className="disclaimer">
                                        N/A indicates Not Available.
                                    </div>
                                )}
                                <a
                                    className="view-all"
                                    href={
                                        moneyMarket
                                            ? `https://${trpDomain}/personal-investing/mutual-funds/prospectuses-reports/money-funds-monthly-portfolio-holdings.html`
                                            : `https://${trpDomain}/personal-investing/funds/mutual-funds/prospectuses-reports/portfolio-holdings.html`
                                    }
                                >
                                    View the Complete Portfolio of Investments
                                </a>
                            </React.Fragment>
                        );
                    }}
                </GqlQueryWrapper>
                <style jsx>{styles}</style>
            </Card>
        );
    }
}

export default TopTenHoldingsBond;
